import MainService from './MainService';
import { getDeviceType, getPageLabelForActivity } from './activityContextHeaders';
import { getClientPublicIpSync } from './clientPublicIp';

const DEDUPE_MS = 1200;
const MAX_FAILS = 3;

let failCount = 0;
let stopped = false;
let lastKey = '';
let lastAt = 0;

function getControlName(el) {
  if (!el) return 'unknown';
  if (el.id) return `#${el.id}`;
  const tag = (el.tagName || 'el').toLowerCase();
  const cls = (el.className && typeof el.className === 'string')
    ? el.className.trim().split(/\s+/).filter(Boolean).slice(0, 2).join('.')
    : '';
  return cls ? `${tag}.${cls}` : tag;
}

function getButtonText(el) {
  if (!el) return 'button';
  const t = (el.innerText || el.textContent || '').trim().replace(/\s+/g, ' ');
  if (t) return t.slice(0, 120);
  const aria = (el.getAttribute('aria-label') || '').trim();
  if (aria) return aria.slice(0, 120);
  const title = (el.getAttribute('title') || '').trim();
  if (title) return title.slice(0, 120);
  if (el.id) return `#${el.id}`;
  return 'button';
}

function visitorAndUser() {
  let visitorName = '';
  let userName = '';
  try {
    const raw = localStorage.getItem('userInfo');
    if (raw) {
      const j = JSON.parse(raw);
      visitorName = (j.Name || j.UserName || j.userName || '').trim();
      userName = (j.UserName || j.userName || '').trim();
    }
  } catch (_) {}
  return { visitorName, userName };
}

/**
 * Registers capturing click tracking for buttons. Call once inside authenticated shell; returns teardown.
 */
export function startUiActivityTracking() {
  const handler = (ev) => {
    if (stopped || failCount >= MAX_FAILS) return;
    if (window.location.pathname.toLowerCase().includes('activity-tracker')) return;

    const el = ev.target && ev.target.closest
      ? ev.target.closest('button, [role="button"], a.btn, .sales-invoice-action-btn, .sales-invoice-icon-btn')
      : null;
    if (!el) return;
    if (el.getAttribute('data-no-track') === 'true') return;

    const actionName = getButtonText(el);
    const controlName = getControlName(el);
    const path = window.location.pathname;
    const dedupeKey = `${path}|${controlName}|${actionName}`;
    const now = Date.now();
    if (dedupeKey === lastKey && now - lastAt < DEDUPE_MS) return;
    lastKey = dedupeKey;
    lastAt = now;

    const pageLabel = getPageLabelForActivity() || path || 'App';
    const { visitorName, userName } = visitorAndUser();
    const ua = navigator.userAgent || '';

    const extra = {
      activityType: 'click',
      controlName,
      actionName,
      pagePath: path,
    };

    const pubIp = getClientPublicIpSync();

    const payload = {
      Page: pageLabel,
      PageUrl: window.location.href,
      IpAddress: pubIp || undefined,
      UserName: userName || undefined,
      VisitorName: visitorName || undefined,
      DeviceName: navigator.platform || '',
      DeviceType: getDeviceType(ua),
      BrowserOs: ua.slice(0, 500),
      ComputerName: typeof navigator.appName === 'string' ? navigator.appName : '',
      Referrer: document.referrer || '',
      HttpMethod: 'UI',
      Endpoint: 'click',
      AdditionalData: JSON.stringify(extra),
    };

    MainService.TrackActivity(payload).then(
      () => {
        failCount = 0;
      },
      () => {
        failCount += 1;
        if (failCount >= MAX_FAILS) stopped = true;
      }
    );
  };

  document.addEventListener('click', handler, true);
  return () => document.removeEventListener('click', handler, true);
}
